import { render } from "./BuildYourBox.vue?vue&type=template&id=309aef4f&scoped=true"
import script from "./BuildYourBox.vue?vue&type=script&lang=js"
export * from "./BuildYourBox.vue?vue&type=script&lang=js"

import "./BuildYourBox.vue?vue&type=style&index=0&id=309aef4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309aef4f"]])

export default __exports__